module.exports = "<ng-transclude us-spinner spinner-theme=\"loadingButton\" spinner-on=\"$ctrl.showSpinner\"></ng-transclude>";